<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <!-- <li><a routerLink="/partnership" class="active">Partnership Opportunities</a></li> -->
                            <!-- <li><a routerLink="/officialpartners" class="">Official Partners</a></li> -->
                            <!-- <li><a routerLink="/players-sponsor">Entry Level Sponsorship</a></li> -->
                            <!-- <li><a routerLink="/commercial" class="">Captain’s Club </a></li> -->
                            <!-- <li><a routerLink="/boundary">The Boundary Club</a></li> -->
                            <!--<li><a routerLink="/advertising">LED Big Screen Advertising</a></li>-->
                            <!-- <li><a routerLink="/indiafixture">India Fixture</a></li> -->
                            <li><a routerLink="/hospitality">Match Day Hospitality</a></li>
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">

        </div>
    </div>
    <div class="commercial-bottom-section cf">
        <div class="commercial-bottom-content">
            <div class="container">
                <div class="commercial-president-main-section cf">
                    <div class="commercial-president-section cf">
                        <div class="commercial-president-image-box">
                            <img [src]="partnershipList?.image">
                        </div>
                        <div class="commercial-president-content-box">
                            <div class="titel-box">
                                <h2 class="titel-name">{{partnershipList?.title}}</h2>
                            </div>
                            <div class="commercial-president-content" [innerHTML]="partnershipList?.description">
                                
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="membership-hero-detail cf">
                    <div class="membership-top-main-section faq-title cf" [ngClass]="{open: i == 0 }" *ngFor="let partnership of partnershipList?.commercial_partnership_detail; let i = index">
                            <a class="membership-top-main-detail faq-add" href="javascript:void(0);">
                                <div class="membership-top-main-detail-left">
                                    <p>{{partnership?.title}}</p>
                                    <h4>{{partnership?.sub_title}}</h4>
                                </div>
                                <div class="membership-top-main-detail-right" *ngIf="partnership?.redirect_url">
                                    <a href="{{partnership?.redirect_url}}" target="_blank">BUY YOUR 2021 BLAST PASS</a>
                                </div>
                            </a>
                            <div class="membership-top-main-content faq-content" [innerHTML]="partnership?.description">
                            </div>
                    </div>
                    <!-- <div class="membership-top-box membership-image">
                        <a href="javascript:void(0)"><img src="assets/images/lccc-fox-logo.svg"></a>
                    </div> -->
                    <!-- <div class="membership-top-detail">
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>Floodlights</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>LED Electronic Scoreboard Advertising</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>Player Sponsorship</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>Stand Sponsorship</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>Pitchside Advertising</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>The Boundary Club</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>Digital Advertising</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>Print Advertising</h4>
                        </div>
                        <div class="membership-top-box">
                            <p>Partnership Opportunities</p>
                            <h4>Community Initiatives</h4>
                        </div>
                        <div class="membership-top-box membership-image">
                            <a href="javascript:void(0)"><img src="assets/images/ic-logo-new.png"></a>
                        </div>
                    </div> -->
                   
                </div>
                <div class="commercial-contact-us-section cf">
                    <div class="titel-box">
                        <h2 class="titel-name">{{partnershipgeneralList?.title}}</h2>
                    </div>
                    <div class="commercial-contact-content" [innerHTML]="partnershipgeneralList?.description">
                        
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-bottom-contact-form" style="background-image: url(assets/images/player-bg-img.png);">
            <div class="container">
                <div class="commercial-bottom-contact-detail">
                    <form class="commercialform " #contactusForm="ngForm" (ngSubmit)="clubContactus(contactusForm)" [ngClass]="{'success': contactSuccess}">
                        <http-message types="success" [data]="contactSuccess" class="err-msg-block">
                        </http-message>
                        <http-message [type]="'error'" [data]="contactError" *ngIf="contactError"
                           class="err-msg-block"></http-message>
                        <div class="join-register-right-box">
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="first_name" [(ngModel)]="contactRequest.first_name"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="First Name" type="text">
                                </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="last_name" [(ngModel)]="contactRequest.last_name"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Last Name" type="text">
                                </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="email" [(ngModel)]="contactRequest.email"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Email Address" type="text">
                                </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="mobile_number" [(ngModel)]="contactRequest.mobile_number"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Mobile No" type="number">
                            </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="company_name" [(ngModel)]="contactRequest.company_name"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Company Name" type="text">
                            </app-form-field>
                            </div>
                            <div class="join-register-right-box-input half">
                                <app-form-field validation="required" name="type_of_event" [(ngModel)]="contactRequest.type_of_event"
                           class="app-group">
                                    <input appFieldInput class="register-style" placeholder="Type of event" name="type_of_event" type="text" >
                            </app-form-field>
                            </div>
                            <div class="join-register-right-box-input full">
                                <app-form-field validation="required" name="message" [(ngModel)]="contactRequest.message"
                           class="app-group">
                                    <textarea appFieldInput name="message" form="usrform" class="register-style" placeholder="Message">Message</textarea>
                                </app-form-field>
                            </div>
                        </div>
                        <div class="join-register-right-box">
                            <div class="join-register-btn"><button id="reg_button" type="submit">Submit</button></div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="commercial-bottom-contact-overlay"></div>
        </div>
        <div class="commercial-bottom-section cf">
            <div class="container">
                <div class="commercial-bottom-partner" *ngFor="let sponsor of sponsorsList?.data">
                    <div class="partner-title">
                        <h2 class="titel-name">{{sponsor?.title}}</h2>
                    </div>
                    <div class="partner-logo-detail">
                        <div class="partner-logo-box" *ngFor="let img of sponsor?.sponsors">
                            <div class="partner-logo-inner">
                                <a href="{{img?.url}}" target="_blank">
                                    <img [src]="img?.image" [alt]="img?.title">
                                </a>
                            </div>
                        </div>
                        
                    </div>
                </div>
                
            </div>
        </div>
        <!-- <div class="commercial-end-section cf">
            <div class="container">
                <div class="fixture-season-tab-content-bottom cf">
                    <div class="fixture-season-tab-content-bottom-detail">
                        <div class="fixture-season-tab-content-image">
                           <img src="assets/images/1605191517_2021-membership-faqs.jpg">    
                        </div>
                        <div class="fixture-season-tab-content-text">
                            <h2>2021 Membership - On Sale Now</h2>
                            <h4>A New Breed of Fox is here!</h4>
                            <div class="fixture-season-content-text">
                                <p>Leicestershire County Cricket Club announce the 2021 membership offering as part of the #ANewBreed campaign. A New Breed of Fox emphasises the new chapter of the club, both on and off the pitch.</p>
                                <p>2021 Memberships launch off the back of an encouraging 2020 season whereby, the Running Foxes reached the Quarter Finals of the Vitality Blast for the first time in 3 years.
                                </p>
                            </div>
                            <div class="fixture-season-tab-content-text-btn">
                                <a href="javascript:void(0)">VIEW DETAILS</a>
                            </div>
                        </div>
                    </div>
                    <div class="fixture-season-tab-content-bottom-detail">
                        <div class="fixture-season-tab-content-image">
                           <img src="assets/images/1605191517_2021-membership-faqs.jpg">    
                        </div>
                        <div class="fixture-season-tab-content-text">
                            <h2>2021 Membership - On Sale Now</h2>
                            <h4>Captain’s Club</h4>
                            <div class="fixture-season-content-text">
                                <p>Leicestershire County Cricket Club announce the 2021 membership offering as part of the #ANewBreed campaign. A New Breed of Fox emphasises the new chapter of the club, both on and off the pitch.</p>
                                <p>2021 Memberships launch off the back of an encouraging 2020 season whereby, the Running Foxes reached the Quarter Finals of the Vitality Blast for the first time in 3 years.
                                </p>
                            </div>
                            <div class="fixture-season-tab-content-text-btn">
                                <a href="javascript:void(0)">VIEW DETAILS</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</section><!-- page ends-->